import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getClientNav: () => NavRoute = () => {
	return {
		name: 'Clients',
		security: 'securityAdministration',
		children: [
			{
				name: 'Clients',
				security: 'securityAdministration',
				exact: true,
				path: 'clients',
			},
			{
				name: 'Letter Codes',
				security: 'securityAdministration',
				exact: true,
				path: 'lettercodes',
			},
		],
	};
};
